import React from 'react'
import PropTypes from 'prop-types'
import Currency from "../_common/Currency";

import moment from "../../helpers/moment";
const _ = require('lodash');



export const BankBilletInfo = (props) => {

    const {empInvoiceBankBillet} = props;

    return(
        <div>
            <div style={{textAlign: 'right', fontSize: '0.6rem', display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
                  <p>
                      <strong>CÓD. BOLETO: </strong>#{empInvoiceBankBillet.code}
                  </p>
                  <p>
                      <strong>DATA DE VENCIMENTO: </strong>
                      {moment.utc(empInvoiceBankBillet.expirationDate).format('DD/MM/YYYY')}
                  </p>
                  <p>
                      <strong>VALOR: </strong>
                      <Currency value={parseFloat(empInvoiceBankBillet.value)}/>
                  </p>
                  <p>
                      <strong>FORMA DE PAGAMENTO: </strong>BOLETO
                  </p>
              </div>
        </div>
    )
}

BankBilletInfo.PropTypes = {
    empInvoiceBankBillet: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired
}

export default BankBilletInfo


// WEBPACK FOOTER //
// ./src/components/BankBillet/BankBilletInfo.js